import React, { useContext, useState, useEffect } from "react";
import useSelectorId from "../../../../utilities/hooks/useSelectorId";
import {
   ECLRichTextViz,
   ECLTextInput,
   ECLUserInfo,
   ECLLoader,
} from "../../../index";
import { UserContext, ToastContext } from "../../../../utilities/contexts";
import {
   endpointRequest,
   sourceOneRestRequest,
   staticURL,
} from "../../../../utilities/requests";
import AskTable from "./components/askTable";
import { translate } from "../../../../utilities/Translate";
import AskChart from "./components/askChart";
import "./AskSourceOne.css";

export default function AskSourceOne(props) {
   const users = useContext(UserContext);
   const addToast = useContext(ToastContext);
   const instance = useSelectorId();
   const [chatHistory, setChatHistory] = useState([]);

   useEffect(() => {
      //If the block is on the homepage, we need to create/access a valid session
      if (props.homepage) {
         let session = sessionStorage.getItem("AISession");
         if (!session) {
            sourceOneRestRequest({
               query_type: "homepage_ai_create_session",
            }).then((res) => {
               sessionStorage.setItem("AISession", res.session_id);
            });
         } else {
            const history = sessionStorage.getItem("chatHistory");
            if (history) {
               const chat = JSON.parse(history);
               setChatHistory(chat);
            }
         }
      } else {
         endpointRequest(
            props.parentObject,
            props.block.id,
            props.block.session,
            "messages",
         )
            .then((res) => {
               if (res.columns.length === 1) {
                  addToast(res.rows[0][0], "error");
               } else {
                  setChatHistory(res.rows);
               }
            })
            .catch((error) => {
               console.error(error);
               addToast(
                  translate(
                     "Error communicating with AI, please contact an administrator.",
                  ),
                  "error",
               );
            });
      }
   }, []);

   //gross
   useEffect(() => {
      let chatWindow = document.querySelector("#ai-chat-window" + instance);
      if (chatWindow) {
         chatWindow.scrollTop = chatWindow.scrollHeight;
      }
   }, [chatHistory]);

   if (!users) {
      return <ECLLoader />;
   }

   function submitChat(e) {
      e.preventDefault();
      const userMessage = e.target[0].value;
      //Creates a session storage with a key named chatHistory
      if (props.homepage) {
         if (!sessionStorage.getItem("chatHistory")) {
            sessionStorage.setItem(
               "chatHistory",
               JSON.stringify([[userMessage, "user", "", ""]]),
            );
         } else {
            let chat = JSON.parse(sessionStorage.chatHistory);
            chat.push([userMessage, "user", "", ""]);
            sessionStorage.setItem("chatHistory", JSON.stringify(chat));
         }
      }
      setChatHistory((prev) => [...prev, [userMessage, "user", ""]]);
      document.querySelector("#ai-input" + instance).disabled = true;
      document.querySelector("#ai-input-submit" + instance).disabled = true;
      let requestParams = {
         query_type: "app_session_set_state",
         key_value_pairs: [
            {
               key: "new_user_message",
               value: {
                  message: userMessage,
               },
            },
         ],
      };

      if (props.block) {
         requestParams.session_id = props.block.session;
         requestParams.block_key = props.block.id;
      } else {
         requestParams.session_id = sessionStorage.getItem("AISession");
      }

      sourceOneRestRequest(requestParams)
         .then(() => {
            endpointRequest(
               props.parentObject ? props.parentObject : null,
               props.block ? props.block.id : null,
               props.block
                  ? props.block.session
                  : sessionStorage.getItem("AISession"),
               "messages",
            )
               .then((res) => {
                  if (res.columns.length === 1) {
                     addToast(res.rows[0][0], "error");
                  } else {
                     setChatHistory(res.rows);
                     if (props.homepage) {
                        sessionStorage.setItem(
                           "chatHistory",
                           JSON.stringify(res.rows),
                        );
                     }
                  }
                  document.querySelector(
                     "#ai-input-submit" + instance,
                  ).disabled = false;
                  document.querySelector("#ai-input" + instance).value = "";
                  document.querySelector("#ai-input" + instance).disabled =
                     false;
                  document.querySelector("#ai-input" + instance).focus();
               })
               .catch((error) => {
                  console.error(error);
                  addToast(
                     translate(
                        "Error communicating with AI, please contact an administrator.",
                     ),
                     "error",
                  );
                  document.querySelector(
                     "#ai-input-submit" + instance,
                  ).disabled = false;
                  document.querySelector("#ai-input" + instance).value = "";
                  document.querySelector("#ai-input" + instance).disabled =
                     false;
                  document.querySelector("#ai-input" + instance).focus();
               });
         })
         .catch((error) => {
            console.error(error);
            addToast(
               translate(
                  "Error communicating with AI, please contact an administrator.",
               ),
               "error",
            );
            document.querySelector("#ai-input-submit" + instance).disabled =
               false;
            document.querySelector("#ai-input" + instance).value = "";
            document.querySelector("#ai-input" + instance).disabled = false;
            document.querySelector("#ai-input" + instance).focus();
         });
   }

   function messageJSX(messageArray) {
      switch (messageArray[2]) {
         case "table":
            return (
               <>
                  <div className="ai-table">
                     <AskTable {...props} endpoint={messageArray[3]} />
                  </div>
               </>
            );

         case "chart":
            return (
               <>
                  <AskChart {...props} endpoint={messageArray[3]} />
               </>
            );

         default:
            return (
               <ECLRichTextViz
                  data={{
                     info: {
                        text:
                           messageArray[1] === "error"
                              ? "\\\\color{#FF0000} Error: " +
                                messageArray[0] +
                                "\\\\color{}"
                              : messageArray[0],
                     },
                  }}
               />
            );
      }
   }

   return (
      <div className="ai-containment-field">
         <label className="widget-label">
            {translate("SourceOne Assistant")}
         </label>
         {chatHistory && (
            <div className="ai-chat-window" id={"ai-chat-window" + instance}>
               {chatHistory.map((h, i) => {
                  if (h[1] === "tool" && h[2] === "") {
                     return null;
                  }
                  return (
                     <div className="ai-chat-row" key={i}>
                        {h[1] === "user" ? (
                           <ECLUserInfo hideName={true} />
                        ) : (
                           <img
                              src={
                                 staticURL + "Logos/S1-Logo-Dark-PWA-48x48.svg"
                              }
                              alt={translate("SourceOne AI Avatar")}
                           />
                        )}
                        <div className="ai-chat-row-content">
                           <p className="ai-chat-row-identity">
                              {h[1] === "user"
                                 ? users.currentUser.username
                                 : translate("SourceOne Assistant")}{" "}
                           </p>
                        </div>
                        <div className="ai-chat-response">{messageJSX(h)}</div>
                     </div>
                  );
               })}
            </div>
         )}
         <form
            onSubmit={submitChat}
            className="ai-chat-submission"
            id={"ai-chat-submission-form" + instance}
         >
            <ECLTextInput
               id={"ai-input" + instance}
               required={true}
               placeholder={translate("Message SourceOne Assistant")}
               list={[]}
            />
            <button id={"ai-input-submit" + instance} type="submit">
               {translate("Ask")}
            </button>
         </form>
      </div>
   );
}
